import { useCallback, useState } from 'react';

import { usePlatformService } from 'core/Hooks';

import { useNativeAddCard } from './mobile/useNativeApp';

type UseHandleAddCardClick = {
  onSuccess?: () => void;
  onFailure?: () => void;
};

export const useHandleAddCardClick = ({
  onSuccess = undefined,
  onFailure = undefined,
}: UseHandleAddCardClick = {}) => {
  const Platform = usePlatformService();
  const [disabled, setDisabled] = useState(false);

  const { openNativeAddCard } = useNativeAddCard({ onSuccess, onFailure });

  // DesktopAction
  // MobileAction
  const handleAddCardClick = useCallback(
    (desktopAction: any) => {
      if (!disabled) {
        setDisabled(true);
        if (Platform.isNative) {
          openNativeAddCard(() => {
            setDisabled(false);
          });
        } else {
          desktopAction();
          setDisabled(false);
        }
      }
    },
    [disabled, openNativeAddCard]
  );

  return { handleAddCardClick };
};
